import DesignButton from 'components/button/DesignButton';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="flex h-screen items-center justify-center bg-design-black">
      <div className="flex h-3/6 w-3/6 flex-col items-center">
        <img className="h-36" alt="login log" src="/sameday_logo.png" />
        <h4 className="mt-3 mb-4 uppercase text-white">404 Page Not Found</h4>
        <div className="w-1/6">
          <DesignButton
            onClickHandler={() => navigate('/')}
            className="text-white"
          >
            Back
          </DesignButton>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
